import Vue from "vue"

export const Authorization =
  'eyJhbGciOiJIUzUxMiJ9.eyJ1c2VyaWQiOjEwODg5Nzk5MjQ2NDIyMzg0NjR9.fZN_vqx89VX12v0rBBm5zTgaLK-7NlBS-S98WzQjC4IMNGelleJLKeDOnd8z_bhrbV58hbh5pQKlQW4qPfL4vw'

// 正式环境用这个
const devUrl = 'https://sca.jnpec.edu.cn/api/'

//线上测试环境用这个
// const devUrl = 'https://ai-test-api.asiait.net/college/'

// 本地测试环境

// const devUrl = 'http://192.168.10.35:8097'
// const devUrl = 'https://ai-test-api.asiait.net/api/'
// const devUrl = 'https://ai-prod.asiait.net/api/'


const productionUrl = '/api/'

export const baseUrl =
  process.env.NODE_ENV === 'development' ? devUrl : productionUrl
// const au = '1060014977140051968' // 孙维月
const au = '1070871374333460480' // 杨志豪
export const userId = process.env.NODE_ENV === 'development' ? au : '' 




//测试环境修改
// @/request/index  修改请求地址
// Vue.config.js 本地打包去掉/mobile
